export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/bg/ilya-yakover-efe053682ec97d330adad93c55dc7bd0.jpg";